export var cifJp = ["301 201", "<g fill='none'><path fill='#FFF' d='M.5.5h300v200H.5z'/><circle cx='150.5' cy='100.5' r='60' fill='#BC002D'/></g>"];
